import { INVALID_EMAIL_ERROR,
  INVALID_FURIGANA_ERROR,
  INVALID_KANJI_ERROR,
  INVALID_JP_PHONE_NO,
  REQUIRED_FIELD_ERROR,
  INVALID_NO_ERROR } from '../locales'

// validation for simple email addresses
export const isEmailValid = (email) => (
  // eslint-disable-next-line max-len
  /^(([^<>()'[\]\\.,;:\s@"]+(\.[^<>()'[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    .test(email) ? undefined : INVALID_EMAIL_ERROR
)

export const isKanji = value => (
  /^[a-zA-Z一-龥 ]+$/.test(value) ? undefined : INVALID_KANJI_ERROR
)

export const isFurigana = value => (
  /([ぁ-んァ-ン])/.test(value) ? undefined : INVALID_FURIGANA_ERROR
)

export const required = value => (value ? undefined : REQUIRED_FIELD_ERROR)

export const isNumber = (value) => (/^\d+$/.test(value) ? undefined : INVALID_NO_ERROR)

export const isValidJPNumber = (value) => (
  // eslint-disable-next-line max-len
  value ? (/^(0([1-9]{1}-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})$/.test(value) ? undefined : INVALID_JP_PHONE_NO) : undefined
)

export const composeValidators = (...validators) => value =>
  validators.reduce((error, validator) => error || validator(value), undefined)

export const isValidName = value => (
  /[一-龯ぁ-んァ-ンa-zA-Z ]/.test(value) ? undefined : INVALID_KANJI_ERROR
)
